/* src/app/modules/display/components/menus/product-menu/building-blocks/menu-section/product-section/wrapping-swimlane-section/wrapping-swimlane-section.component.scss */
/*# sourceMappingURL=wrapping-swimlane-section.component.css.map */
